<template>
  <div class="card column" :class="showJob ? 'detail' : ''">
    <div v-if="!showJob" class="column justify-space align-center">
      <svg
        width="92"
        height="61"
        viewBox="0 0 92 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M88.4037 40.8225C87.7394 41.5491 86.9155 42.09 86.0215 42.51H86.0204C85.9363 42.55 85.8522 42.5888 85.767 42.6256H85.7659L85.7648 42.6266L85.7638 42.6256H85.7627C85.7627 42.6257 85.7627 42.6258 85.7626 42.626C85.7626 42.6261 85.7625 42.6262 85.7624 42.6263C85.7623 42.6264 85.7622 42.6265 85.762 42.6266C85.7619 42.6266 85.7617 42.6266 85.7616 42.6266H85.7605L85.7594 42.6256C85.7584 42.6266 85.7584 42.6266 85.7573 42.6256L85.7562 42.6266L85.7551 42.6256H85.7541C85.753 42.6266 85.753 42.6266 85.7519 42.6256H85.7508C85.1524 42.8847 84.5379 43.1047 83.9111 43.2841C80.2251 44.3311 76.3509 44.5337 72.576 43.8769C72.5038 43.8639 72.4326 43.8509 72.3604 43.838V35.081C72.4315 35.0508 72.5038 35.0205 72.576 34.9914C73.0473 34.796 73.5243 34.6164 74.0071 34.4526C74.7015 34.2151 75.4057 34.0114 76.1196 33.8416C78.4487 33.2772 80.8519 33.0826 83.2414 33.265C83.676 33.2974 84.1095 33.3442 84.5419 33.4054C85.4467 33.5317 86.3957 33.7519 87.2304 34.1341H87.2314C87.3533 34.1914 87.473 34.2507 87.5917 34.3144C88.3336 34.7172 88.959 35.271 89.3408 36.03C89.4779 36.3026 89.5767 36.5929 89.6341 36.8926V36.8948C89.6557 36.9984 89.6708 37.1032 89.6826 37.2068C89.8185 38.4851 89.289 39.853 88.4037 40.8225Z"
            fill="#F2F2F2"
          />
          <path
            d="M89.6827 37.2069C89.6721 37.2095 89.6612 37.2109 89.6503 37.2112C87.803 37.2922 85.9583 37.4124 84.116 37.5718H84.1127C84.1052 37.5729 84.0987 37.5729 84.0912 37.5739C82.1997 37.738 80.3121 37.9435 78.4285 38.1904C78.3487 38.2012 78.27 38.212 78.1912 38.2217C76.8886 38.3956 75.5884 38.5884 74.2907 38.8004C73.718 38.8943 73.1465 38.9922 72.576 39.0941C72.5038 39.107 72.4326 39.1189 72.3604 39.1329V38.8058C72.4326 38.7918 72.5048 38.7799 72.576 38.7669C74.4762 38.4301 76.3828 38.1361 78.2959 37.8849C78.7768 37.8201 79.2585 37.7589 79.7409 37.7013C81.1342 37.5329 82.5296 37.3875 83.9272 37.2652C84.0297 37.2565 84.1311 37.2479 84.2335 37.2392C86.0226 37.087 87.8141 36.9715 89.6083 36.8927C89.6169 36.8923 89.6257 36.893 89.6342 36.8948C89.8067 36.91 89.8434 37.1691 89.6827 37.2069Z"
            fill="white"
          />
          <path
            d="M85.8465 42.3074C83.5452 42.3243 81.278 41.3474 79.6502 39.7303C79.1909 39.2723 78.7862 38.7626 78.4441 38.2113C78.3344 38.0351 78.0777 38.2294 78.1865 38.404C79.4506 40.4338 81.5564 41.8797 83.8781 42.4114C84.5374 42.561 85.2118 42.6332 85.8878 42.6267C86.0942 42.6252 86.0514 42.3059 85.8465 42.3074V42.3074Z"
            fill="white"
          />
          <path
            d="M76.1196 33.8416C76.1098 33.8719 76.0921 33.8991 76.0685 33.9205C76.0448 33.9419 76.016 33.9568 75.9848 33.9636C75.4574 34.1019 74.9479 34.3012 74.4665 34.5574C73.7635 34.9291 73.1251 35.4122 72.576 35.9879C72.5469 36.017 72.5189 36.0462 72.4919 36.0764C72.4466 36.1239 72.4035 36.1725 72.3604 36.2222V35.7514C72.4294 35.678 72.5016 35.6057 72.576 35.5366C73.0095 35.1211 73.4898 34.7573 74.0071 34.4526C74.7015 34.2151 75.4057 34.0114 76.1196 33.8416Z"
            fill="white"
          />
          <path
            d="M87.4214 34.0489C85.9575 34.6788 84.7326 35.76 83.925 37.1351C83.9087 37.1745 83.9085 37.2187 83.9245 37.2582C83.9405 37.2977 83.9714 37.3292 84.0105 37.3461C84.0499 37.3616 84.0937 37.3614 84.1329 37.3455C84.1722 37.3296 84.2038 37.2991 84.2212 37.2605C84.992 35.9617 86.1549 34.9416 87.5423 34.3472C87.7326 34.2658 87.6121 33.9673 87.4214 34.0489L87.4214 34.0489Z"
            fill="white"
          />
          <path
            d="M91.8341 24.8795C91.5839 25.8317 91.104 26.6944 90.5077 27.4814L90.5066 27.4825C90.4515 27.5559 90.3944 27.6304 90.3351 27.7017V27.7028C89.9211 28.2134 89.474 28.6963 88.9968 29.1484C87.2814 30.785 85.3438 32.1709 83.2414 33.2651C79.9339 34.9947 76.2372 36.0171 72.576 36.0754C72.548 36.0765 72.52 36.0765 72.4919 36.0765C72.4477 36.0776 72.4035 36.0776 72.3604 36.0776V31.1706C72.4304 31.0367 72.5027 30.9028 72.576 30.77C73.5275 29.056 74.6877 27.4669 76.0302 26.039C76.0625 26.0034 76.0959 25.9678 76.1294 25.9332C76.634 25.3999 77.1632 24.8921 77.7167 24.4098C79.8464 22.5352 82.3076 21.0759 84.9733 20.1074C85.8328 19.7987 86.7753 19.5514 87.6919 19.5028C87.8267 19.4953 87.9605 19.492 88.0953 19.4931C88.9397 19.505 89.7495 19.7047 90.4408 20.1992C90.6883 20.3772 90.9104 20.5883 91.1008 20.8265C91.1676 20.9096 91.2291 20.9949 91.2884 21.0824V21.0834C92.0023 22.1523 92.1684 23.6087 91.8341 24.8795Z"
            fill="#F2F2F2"
          />
          <path
            d="M91.2884 21.0823V21.0834C91.2804 21.0904 91.2717 21.0965 91.2625 21.1018C89.6665 22.0313 88.0905 22.9947 86.5348 23.992C86.5326 23.993 86.5316 23.9941 86.5294 23.9952C86.5232 23.9996 86.5167 24.0035 86.51 24.0071C84.9107 25.0327 83.3341 26.093 81.7802 27.1877C81.7154 27.2331 81.6497 27.2795 81.5839 27.3259C80.5109 28.0849 79.449 28.8601 78.3983 29.6515C76.414 31.1479 74.4733 32.6997 72.576 34.3069C72.5038 34.3674 72.4326 34.4289 72.3604 34.4904V34.0705C72.4315 34.0089 72.5038 33.9474 72.576 33.8869C73.3029 33.2726 74.0362 32.6669 74.776 32.0699C74.9971 31.8917 75.2192 31.7136 75.4413 31.5376C77.4148 29.9646 79.4325 28.4502 81.4944 26.9945H81.4954C81.901 26.7084 82.3071 26.4248 82.714 26.1437C83.8701 25.3469 85.0391 24.5692 86.221 23.8106C86.3062 23.7555 86.3925 23.7005 86.4787 23.6454C87.9917 22.678 89.5245 21.7423 91.077 20.8383C91.0846 20.8337 91.0925 20.8297 91.1008 20.8264C91.2625 20.7617 91.4145 20.9754 91.2884 21.0823Z"
            fill="white"
          />
          <path
            d="M90.2586 27.3835C88.2286 28.4688 85.7676 28.658 83.5758 27.983C82.9565 27.791 82.3616 27.5278 81.8029 27.1987C81.624 27.0937 81.4868 27.3852 81.6642 27.4892C83.7255 28.6988 86.2611 29 88.5638 28.3911C89.217 28.2169 89.8478 27.9672 90.4434 27.6471C90.6255 27.5498 90.4395 27.2869 90.2586 27.3835V27.3835Z"
            fill="white"
          />
          <path
            d="M75.0695 31.3337C74.969 30.7685 74.9345 30.1935 74.9668 29.6204C75.0394 28.3132 75.4392 27.0453 76.1294 25.9333C76.6346 25.4001 77.1639 24.8923 77.7171 24.4097C77.7223 24.4412 77.7193 24.4736 77.7082 24.5036C77.6971 24.5336 77.6784 24.5602 77.6539 24.5808C77.2513 24.9486 76.8926 25.3619 76.585 25.8124C75.4863 27.4178 75.0574 29.3895 75.3899 31.307C75.3953 31.3287 75.395 31.3515 75.3891 31.3731C75.3832 31.3947 75.3718 31.4144 75.3561 31.4304C75.333 31.4505 75.3051 31.4642 75.2751 31.4701C75.2451 31.4761 75.2141 31.4741 75.1851 31.4643C75.1561 31.4545 75.1302 31.4373 75.1099 31.4144C75.0896 31.3915 75.0757 31.3637 75.0695 31.3337Z"
            fill="white"
          />
          <path
            d="M87.8215 19.3378C86.8174 20.5764 86.2344 22.1035 86.1572 23.6969C86.161 23.7393 86.1813 23.7785 86.2138 23.8061C86.2463 23.8336 86.2884 23.8472 86.3308 23.8439C86.3729 23.8394 86.4116 23.8188 86.439 23.7865C86.4663 23.7541 86.4802 23.7124 86.4777 23.6701C86.5577 22.1615 87.1142 20.7173 88.067 19.5458C88.1978 19.3851 87.9526 19.1768 87.8215 19.3378Z"
            fill="white"
          />
          <path
            d="M76.6535 22.8852V22.8863C76.6459 22.9791 76.6373 23.0709 76.6276 23.1626V23.1648C76.5526 23.818 76.4355 24.4657 76.2771 25.1038C76.2016 25.4169 76.1196 25.7279 76.0302 26.0388C76.0194 26.0788 76.0075 26.1187 75.9956 26.1576V26.1587C75.7322 27.063 75.4176 27.9515 75.0531 28.82C74.3826 30.4189 73.5527 31.946 72.576 33.3782C72.5059 33.483 72.4337 33.5877 72.3604 33.6913V16.7841C72.4326 16.7798 72.5038 16.7798 72.576 16.7819C72.6105 16.7819 72.645 16.783 72.6796 16.7852C72.9838 16.8012 73.2844 16.8597 73.5725 16.959C73.6739 16.9925 73.772 17.0303 73.8691 17.0724C75.0456 17.5884 75.9698 18.7264 76.3709 19.9777C76.6718 20.9148 76.7322 21.9005 76.6535 22.8852Z"
            fill="#F2F2F2"
          />
          <path
            d="M73.869 17.0725C73.8665 17.0831 73.8625 17.0933 73.8571 17.1027C73.4204 17.9524 72.9934 18.8064 72.576 19.6647C72.5038 19.8127 72.4315 19.9616 72.3604 20.1096V19.3754C72.4315 19.2286 72.5034 19.0817 72.576 18.9349C72.8985 18.2806 73.2263 17.6292 73.5595 16.9807C73.5632 16.9732 73.5675 16.9659 73.5725 16.9591C73.6717 16.8166 73.9175 16.9138 73.869 17.0725Z"
            fill="white"
          />
          <path
            d="M76.688 23.0591C76.6686 23.0936 76.6491 23.1282 76.6276 23.1627C76.3109 23.7152 75.934 24.2308 75.5039 24.7001C74.6777 25.5975 73.6827 26.3229 72.576 26.8346C72.5048 26.8691 72.4326 26.9015 72.3604 26.9318V26.5809C72.4326 26.5485 72.5048 26.515 72.576 26.4805C74.178 25.7155 75.5087 24.4793 76.3903 22.9371C76.4031 22.915 76.4204 22.896 76.4411 22.8813C76.4618 22.8665 76.4854 22.8564 76.5103 22.8516C76.5353 22.8468 76.561 22.8474 76.5857 22.8534C76.6104 22.8594 76.6335 22.8706 76.6535 22.8863C76.6671 22.8954 76.6788 22.907 76.6879 22.9206C76.697 22.9342 76.7033 22.9495 76.7065 22.9655C76.7097 22.9816 76.7097 22.9981 76.7065 23.0141C76.7033 23.0302 76.697 23.0455 76.688 23.0591Z"
            fill="white"
          />
          <path
            d="M72.5762 3.56283V11.7681H72.3605V11.6807H0.21568V11.7681H0V3.56283C0.000926168 2.61819 0.376158 1.71251 1.04335 1.04455C1.71053 0.376593 2.61517 0.00092724 3.55871 0H69.0175C69.961 0.00092724 70.8656 0.376593 71.5328 1.04455C72.2 1.71251 72.5752 2.61819 72.5762 3.56283Z"
            :class="
              job.status_solicitacao == 'aberto' ? 'svg-color4' : 'svg-color5'
            "
          />
          <path
            d="M69.0175 0H3.55871C2.61517 0.00092724 1.71053 0.376593 1.04335 1.04455C0.376158 1.71251 0.000926168 2.61819 0 3.56283V50.4195C0.000926168 51.3641 0.376158 52.2698 1.04335 52.9377C1.71053 53.6057 2.61517 53.9814 3.55871 53.9823H69.0175C69.961 53.9814 70.8656 53.6057 71.5328 52.9377C72.2 52.2698 72.5752 51.3641 72.5762 50.4195V3.56283C72.5752 2.61819 72.2 1.71251 71.5328 1.04455C70.8656 0.376593 69.961 0.00092724 69.0175 0ZM72.3605 50.4195C72.3594 51.3068 72.0068 52.1574 71.3801 52.7848C70.7534 53.4123 69.9037 53.7652 69.0175 53.7664H3.55871C2.67243 53.7652 1.82277 53.4123 1.19608 52.7848C0.569384 52.1574 0.21681 51.3068 0.21568 50.4195V3.56283C0.21681 2.67553 0.569384 1.82489 1.19608 1.19747C1.82277 0.570045 2.67243 0.217061 3.55871 0.215929H69.0175C69.9037 0.217062 70.7534 0.570045 71.3801 1.19747C72.0068 1.82489 72.3594 2.67553 72.3605 3.56283V50.4195Z"
            fill="#3F3D56"
          />
          <path
            d="M14.6661 8.04344C15.8572 8.04344 16.8229 7.07669 16.8229 5.88415C16.8229 4.6916 15.8572 3.72485 14.6661 3.72485C13.4749 3.72485 12.5093 4.6916 12.5093 5.88415C12.5093 7.07669 13.4749 8.04344 14.6661 8.04344Z"
            fill="white"
          />
          <path
            d="M57.9097 8.04344C59.1009 8.04344 60.0665 7.07669 60.0665 5.88415C60.0665 4.6916 59.1009 3.72485 57.9097 3.72485C56.7186 3.72485 55.7529 4.6916 55.7529 5.88415C55.7529 7.07669 56.7186 8.04344 57.9097 8.04344Z"
            fill="white"
          />
          <path
            d="M20.8977 29.9604H8.06728C7.52372 29.9598 7.00261 29.7434 6.61826 29.3586C6.2339 28.9738 6.01771 28.4521 6.01709 27.9079V21.8367C6.01771 21.2926 6.2339 20.7708 6.61826 20.386C7.00261 20.0012 7.52372 19.7848 8.06728 19.7842H20.8977C21.4412 19.7848 21.9623 20.0012 22.3467 20.386C22.731 20.7708 22.9472 21.2926 22.9478 21.8367V27.9079C22.9472 28.4521 22.731 28.9738 22.3467 29.3586C21.9623 29.7434 21.4412 29.9598 20.8977 29.9604Z"
            :class="
              job.status_solicitacao == 'aberto' ? 'svg-color4' : 'svg-color5'
            "
          />
          <path
            d="M42.7243 29.9604H29.8939C29.3504 29.9598 28.8293 29.7434 28.4449 29.3586C28.0606 28.9738 27.8444 28.4521 27.8438 27.9079V21.8367C27.8444 21.2926 28.0606 20.7708 28.4449 20.386C28.8293 20.0012 29.3504 19.7848 29.8939 19.7842H42.7243C43.2679 19.7848 43.789 20.0012 44.1733 20.386C44.5577 20.7708 44.7739 21.2926 44.7745 21.8367V27.9079C44.7739 28.4521 44.5577 28.9738 44.1733 29.3586C43.789 29.7434 43.2679 29.9598 42.7243 29.9604Z"
            :class="
              job.status_solicitacao == 'aberto' ? 'svg-color4' : 'svg-color5'
            "
          />
          <path
            d="M42.7244 45.6467H29.8941C29.334 45.646 28.7971 45.423 28.4011 45.0266C28.0051 44.6301 27.7824 44.0926 27.7817 43.5319V37.4607C27.7824 36.9 28.0051 36.3625 28.4011 35.966C28.7971 35.5696 29.334 35.3466 29.8941 35.3459H42.7244C43.2844 35.3466 43.8214 35.5696 44.2174 35.966C44.6134 36.3625 44.8361 36.9 44.8367 37.4607V43.5319C44.8361 44.0926 44.6134 44.6301 44.2174 45.0266C43.8214 45.423 43.2844 45.646 42.7244 45.6467Z"
            fill="#F2F2F2"
          />
          <path
            d="M20.8553 45.6467H8.02491C7.46488 45.646 6.92797 45.423 6.53198 45.0266C6.13598 44.6301 5.91323 44.0926 5.9126 43.5319V37.4607C5.91323 36.9 6.13598 36.3625 6.53198 35.966C6.92797 35.5696 7.46488 35.3466 8.02491 35.3459H20.8553C21.4153 35.3466 21.9522 35.5696 22.3482 35.966C22.7442 36.3625 22.967 36.9 22.9676 37.4607V43.5319C22.967 44.0926 22.7442 44.6301 22.3482 45.0266C21.9522 45.423 21.4153 45.646 20.8553 45.6467Z"
            fill="#F2F2F2"
          />
          <path
            d="M64.5515 45.6467H51.7212C51.1612 45.646 50.6243 45.423 50.2283 45.0266C49.8323 44.6301 49.6095 44.0926 49.6089 43.5319V37.4607C49.6095 36.9 49.8323 36.3625 50.2283 35.966C50.6243 35.5696 51.1612 35.3466 51.7212 35.3459H64.5515C65.1116 35.3466 65.6485 35.5696 66.0445 35.966C66.4405 36.3625 66.6632 36.9 66.6639 37.4607V43.5319C66.6632 44.0926 66.4405 44.6301 66.0445 45.0266C65.6485 45.423 65.1116 45.646 64.5515 45.6467Z"
            fill="#F2F2F2"
          />
          <path
            d="M64.5515 29.9726H51.7212C51.1612 29.972 50.6243 29.749 50.2283 29.3525C49.8323 28.956 49.6095 28.4185 49.6089 27.8578V21.7866C49.6095 21.226 49.8323 20.6884 50.2283 20.292C50.6243 19.8955 51.1612 19.6725 51.7212 19.6719H64.5515C65.1116 19.6725 65.6485 19.8955 66.0445 20.292C66.4405 20.6884 66.6632 21.226 66.6639 21.7866V27.8578C66.6632 28.4185 66.4405 28.956 66.0445 29.3525C65.6485 29.749 65.1116 29.972 64.5515 29.9726Z"
            fill="#F2F2F2"
          />
          <path
            d="M14.482 28.3554C16.4035 28.3554 17.9612 26.796 17.9612 24.8723C17.9612 22.9486 16.4035 21.3892 14.482 21.3892C12.5606 21.3892 11.0029 22.9486 11.0029 24.8723C11.0029 26.796 12.5606 28.3554 14.482 28.3554Z"
            fill="white"
          />
          <path
            d="M14.1373 26.201C14.059 26.2012 13.9828 26.1758 13.9202 26.1288L13.9163 26.1259L13.0987 25.4992C13.0607 25.4702 13.0289 25.434 13.005 25.3926C12.9811 25.3513 12.9655 25.3056 12.9592 25.2582C12.9529 25.2108 12.956 25.1627 12.9683 25.1165C12.9807 25.0704 13.0019 25.0271 13.031 24.9891C13.06 24.9512 13.0962 24.9194 13.1375 24.8955C13.1789 24.8715 13.2245 24.856 13.2718 24.8498C13.3191 24.8435 13.3672 24.8467 13.4133 24.859C13.4594 24.8714 13.5027 24.8928 13.5405 24.9219L14.0701 25.3284L15.3216 23.6944C15.3506 23.6565 15.3868 23.6247 15.4281 23.6008C15.4694 23.5769 15.515 23.5614 15.5623 23.5551C15.6096 23.5489 15.6577 23.552 15.7038 23.5644C15.7498 23.5767 15.793 23.598 15.8309 23.6271L15.8231 23.6377L15.8311 23.6272C15.9075 23.686 15.9574 23.7727 15.97 23.8683C15.9826 23.9638 15.9568 24.0605 15.8983 24.1371L14.4263 26.0591C14.3922 26.1034 14.3484 26.1393 14.2983 26.1639C14.2482 26.1885 14.1931 26.2012 14.1373 26.201Z"
            :class="
              job.status_solicitacao == 'aberto' ? 'svg-color4' : 'svg-color5'
            "
          />
          <path
            d="M36.3707 28.3054C38.2922 28.3054 39.8498 26.7459 39.8498 24.8222C39.8498 22.8986 38.2922 21.3391 36.3707 21.3391C34.4493 21.3391 32.8916 22.8986 32.8916 24.8222C32.8916 26.7459 34.4493 28.3054 36.3707 28.3054Z"
            fill="white"
          />
          <path
            d="M36.0266 26.151C35.9484 26.1512 35.8722 26.1258 35.8095 26.0788L35.8056 26.0759L34.988 25.4492C34.9116 25.3905 34.8615 25.3038 34.8488 25.2082C34.8362 25.1126 34.862 25.0159 34.9206 24.9393C34.9792 24.8628 35.0658 24.8126 35.1613 24.8C35.2568 24.7873 35.3534 24.8132 35.4299 24.8718L35.9595 25.2784L37.211 23.6443C37.24 23.6064 37.2762 23.5746 37.3175 23.5507C37.3588 23.5268 37.4044 23.5113 37.4517 23.5051C37.499 23.4988 37.547 23.502 37.5931 23.5143C37.6392 23.5267 37.6824 23.548 37.7203 23.577L37.7125 23.5876L37.7205 23.5772C37.7968 23.6359 37.8468 23.7226 37.8594 23.8182C37.872 23.9138 37.8462 24.0105 37.7877 24.0871L36.3156 26.0091C36.2816 26.0534 36.2378 26.0892 36.1877 26.1138C36.1376 26.1384 36.0824 26.1512 36.0266 26.151Z"
            :class="
              job.status_solicitacao == 'aberto' ? 'svg-color4' : 'svg-color5'
            "
          />
          <path
            d="M59.8846 41.2586C59.9989 41.1334 60.0844 40.9847 60.1351 40.823C60.1858 40.6612 60.2004 40.4902 60.178 40.3222C60.1555 40.1541 60.0966 39.993 60.0052 39.8502C59.9139 39.7074 59.7923 39.5865 59.6492 39.4958L57.7069 29.1125L55.3447 29.9895L57.9967 39.9201C57.8605 40.1709 57.8209 40.463 57.8855 40.7411C57.95 41.0192 58.1142 41.2639 58.3469 41.4289C58.5796 41.5938 58.8647 41.6676 59.1481 41.6362C59.4315 41.6048 59.6936 41.4705 59.8846 41.2586Z"
            fill="#A0616A"
          />
          <path
            d="M41.036 25.415C41.0419 25.4795 41.0427 25.5443 41.0384 25.6089L45.6313 29.148L46.9337 28.6125L47.9978 30.4748L45.7841 31.6471C45.6052 31.7418 45.4005 31.7759 45.2007 31.7442C45.0009 31.7125 44.8167 31.6168 44.6759 31.4714L40.085 26.7329C39.842 26.7878 39.5881 26.7673 39.357 26.6741C39.1259 26.581 38.9286 26.4196 38.7913 26.2115C38.6541 26.0033 38.5834 25.7583 38.5887 25.5089C38.5939 25.2596 38.6749 25.0177 38.8207 24.8156C38.9666 24.6134 39.1705 24.4605 39.4053 24.3772C39.6401 24.2939 39.8947 24.2841 40.1352 24.3492C40.3757 24.4143 40.5907 24.5511 40.7516 24.7415C40.9125 24.9319 41.0117 25.1668 41.036 25.415H41.036Z"
            fill="#A0616A"
          />
          <path
            d="M51.7665 59.6881H50.4445L49.8154 55.6624L51.7668 55.6625L51.7665 59.6881Z"
            fill="#A0616A"
          />
          <path
            d="M52.1038 60.9712L47.8408 60.971V60.917C47.8408 60.6989 47.8837 60.4829 47.9671 60.2813C48.0505 60.0798 48.1727 59.8966 48.3268 59.7424C48.4809 59.5881 48.6638 59.4658 48.8651 59.3823C49.0664 59.2988 49.2822 59.2559 49.5001 59.2559H49.5002L52.1039 59.256L52.1038 60.9712Z"
            fill="#2F2E41"
          />
          <path
            d="M56.7269 59.6881H55.4049L54.7759 55.6624L56.7272 55.6625L56.7269 59.6881Z"
            fill="#A0616A"
          />
          <path
            d="M57.0642 60.9712L52.8013 60.971V60.917C52.8013 60.6989 52.8442 60.4829 52.9276 60.2813C53.011 60.0798 53.1332 59.8966 53.2873 59.7424C53.4413 59.5881 53.6242 59.4658 53.8256 59.3823C54.0269 59.2988 54.2426 59.2559 54.4605 59.2559H54.4606L57.0643 59.256L57.0642 60.9712Z"
            fill="#2F2E41"
          />
          <path
            d="M50.1698 58.8926C50.0491 58.8927 49.9328 58.8477 49.8435 58.7664C49.7542 58.685 49.6985 58.5732 49.6873 58.4529L48.5352 42.9396L48.5896 42.9351L56.5181 42.2827L56.5202 42.3391L57.1505 58.4097C57.1529 58.475 57.1422 58.5401 57.1189 58.6011C57.0957 58.6622 57.0603 58.7179 57.0151 58.7649C56.9698 58.812 56.9155 58.8494 56.8554 58.875C56.7954 58.9005 56.7308 58.9137 56.6655 58.9137H55.111C54.9949 58.9142 54.8825 58.8729 54.7944 58.7972C54.7064 58.7216 54.6485 58.6167 54.6313 58.5017L52.5203 45.5195C52.5182 45.5061 52.5112 45.494 52.5006 45.4855C52.49 45.4771 52.4766 45.4729 52.4631 45.4739C52.4495 45.4749 52.4369 45.481 52.4276 45.4908C52.4184 45.5007 52.4132 45.5138 52.413 45.5273L52.3173 58.3453C52.3163 58.4691 52.2682 58.5878 52.1828 58.6773C52.0973 58.7669 51.981 58.8204 51.8576 58.827L50.1959 58.8919C50.1872 58.8924 50.1785 58.8926 50.1698 58.8926Z"
            fill="#2F2E41"
          />
          <path
            d="M51.5227 23.334C52.9855 23.334 54.1713 22.1467 54.1713 20.6822C54.1713 19.2177 52.9855 18.0305 51.5227 18.0305C50.0599 18.0305 48.874 19.2177 48.874 20.6822C48.874 22.1467 50.0599 23.334 51.5227 23.334Z"
            fill="#A0616A"
          />
          <path
            d="M52.0358 43.9289C50.8781 43.9255 49.726 43.7678 48.6099 43.4602C48.5025 43.4289 48.4091 43.3614 48.3456 43.2693C48.282 43.1771 48.2521 43.0658 48.2609 42.9542C48.6175 37.5891 48.7013 33.4256 47.9515 30.5448C47.632 29.3171 47.7771 28.024 48.3496 26.9971C49.2112 25.4518 50.7949 24.5113 52.4842 24.5438C52.5649 24.5453 52.6464 24.5482 52.7288 24.5524C55.2924 24.6846 57.2901 27.0065 57.1819 29.7285L56.6663 42.7024C56.6644 42.7971 56.6346 42.889 56.5805 42.9667C56.5265 43.0444 56.4507 43.1044 56.3627 43.139C54.9794 43.66 53.5137 43.9276 52.0358 43.9289Z"
            fill="#3F3D56"
          />
          <path
            d="M48.3871 31.5408L46.4031 29.1068C46.3467 29.0376 46.3058 28.957 46.2833 28.8705C46.2608 28.784 46.2571 28.6936 46.2726 28.6056C46.2881 28.5176 46.3224 28.4339 46.3731 28.3603C46.4238 28.2868 46.4897 28.225 46.5664 28.1792L49.2539 26.5759C49.6095 26.2887 50.0643 26.1544 50.5186 26.2024C50.973 26.2504 51.3897 26.4769 51.6775 26.8321C51.9653 27.1873 52.1007 27.6423 52.0539 28.0973C52.0071 28.5522 51.7821 28.9701 51.428 29.2591L49.3276 31.5667C49.2674 31.6327 49.1938 31.685 49.1116 31.72C49.0294 31.755 48.9407 31.7718 48.8514 31.7694C48.7622 31.7669 48.6745 31.7452 48.5944 31.7058C48.5143 31.6664 48.4436 31.6101 48.3871 31.5408Z"
            fill="#3F3D56"
          />
          <path
            d="M54.6289 31.2354C54.5474 31.1989 54.4747 31.1452 54.4158 31.078C54.3569 31.0108 54.3132 30.9317 54.2877 30.8461L53.3945 27.8549C53.2006 27.4407 53.1787 26.9664 53.3337 26.5361C53.4886 26.1058 53.8076 25.7545 54.2209 25.5594C54.6341 25.3642 55.1078 25.3411 55.538 25.4952C55.9682 25.6492 56.3199 25.9678 56.5158 26.381L58.243 28.9925C58.2923 29.067 58.325 29.1513 58.3388 29.2396C58.3526 29.3279 58.3472 29.4182 58.3231 29.5042C58.2989 29.5903 58.2565 29.6701 58.1987 29.7383C58.141 29.8064 58.0692 29.8613 57.9884 29.8992L55.1463 31.2311C55.0654 31.269 54.9773 31.2891 54.888 31.2898C54.7988 31.2905 54.7103 31.272 54.6289 31.2354Z"
            fill="#3F3D56"
          />
          <path
            d="M52.8317 22.8581L50.8683 22.4082C50.6658 22.3618 50.4225 22.2732 50.3944 22.0671C50.3567 21.7902 50.7548 21.5973 50.718 21.3202C50.6825 21.0518 50.3198 21.0172 50.0613 20.938C49.8204 20.8534 49.6219 20.6783 49.5078 20.4498C49.3936 20.2213 49.3727 19.9573 49.4496 19.7136C49.1698 20.1084 48.5306 20.1422 48.1677 19.8224C47.8048 19.5026 47.7352 18.9224 47.9532 18.4903C48.0709 18.2781 48.237 18.0967 48.4379 17.9609C48.6389 17.8251 48.869 17.7386 49.1096 17.7086C49.5934 17.6537 50.0825 17.745 50.514 17.9707C50.5428 17.6648 50.9243 17.5408 51.2312 17.5381C51.8687 17.5455 52.488 17.7517 53.003 18.128C53.5179 18.5043 53.9029 19.032 54.1044 19.6376C54.4809 20.8524 54.2291 22.1841 53.1754 22.8949L52.8317 22.8581Z"
            fill="#2F2E41"
          />
          <path
            d="M72.6074 61.0001H31.5204C31.4918 61.0001 31.4644 60.9887 31.4442 60.9685C31.424 60.9482 31.4126 60.9208 31.4126 60.8921C31.4126 60.8635 31.424 60.8361 31.4442 60.8158C31.4644 60.7956 31.4918 60.7842 31.5204 60.7842H72.6074C72.636 60.7842 72.6634 60.7956 72.6836 60.8158C72.7038 60.8361 72.7152 60.8635 72.7152 60.8921C72.7152 60.9208 72.7038 60.9482 72.6836 60.9685C72.6634 60.9887 72.636 61.0001 72.6074 61.0001Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="92" height="61" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <div class="title">Atendimento {{ job.forma_atendimento }}</div>
      <div
        class="status"
        :class="job.status_solicitacao == 'aberto' ? 'open' : 'close'"
      >
        {{ job.status_cliente }}
      </div>
      <div class="column align-center date">
        <span>Agendando Para</span>
        {{
          new Date(job.dh_agendamento_cliente).toLocaleString().substr(0, 10)
        }}
        <div>
          {{
            new Date(job.dh_agendamento_cliente).toLocaleString().slice(11, 16)
          }}
        </div>
      </div>

      <Button layout="remote-continue" class="more" @click="showJob = true"
        >MAIS DETALHES</Button
      >
    </div>

    <div v-if="showJob" class="column opened">
      <div class="header row align-center">
        <div class="id">
          ID <b>{{ job.id }}</b>
        </div>
        <div class="titled">Atendimento {{ job.forma_atendimento }}</div>
      </div>

      <div class="content">
        <span class="sub">Problema que você relatou</span>
        <div class="problem" v-html="job.problema.replace(/\n/g, '<br />')"></div>
        <div class="info column align-center">
          <div class="column text-center">
            <span class="sub">Status</span>
            <div
              class="status"
              :class="job.status_solicitacao == 'aberto' ? 'open' : 'close'"
            >
              {{ job.status_cliente }}
            </div>
          </div>
          <br />
          <div class="column text-center">
            <span class="sub">Agendando para</span>
            {{
              new Date(job.dh_agendamento_cliente)
                .toLocaleString()
                .substr(0, 10)
            }}
          </div>
        </div>
        <div
          class="column address"
          v-if="job.forma_atendimento == 'presencial'"
        >
          <span class="sub">Local de atendimento</span>
          {{
            job.logradouro +
            ", " +
            job.numero +
            " " +
            (job.complemento || "") +
            " - " +
            job.bairro
          }}
          <br />
          {{ job.cidade + "/" + job.estado + " - " + job.cep }}
        </div>
        <Button
          v-if="job.deslocamento_monitorado && remote"
          layout="remote-how"
          class="goMap"
          @click="map(job)"
        >
          <svg
            width="28"
            height="30"
            viewBox="0 0 32 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.314 26.8698L16 38L4.68601 26.8698C2.44845 24.6684 0.924679 21.8638 0.307382 18.8106C-0.309914 15.7573 0.00698721 12.5925 1.21801 9.71645C2.42904 6.84036 4.4798 4.38214 7.11097 2.65263C9.74213 0.923121 12.8355 0 16 0C19.1645 0 22.2579 0.923121 24.889 2.65263C27.5202 4.38214 29.571 6.84036 30.782 9.71645C31.993 12.5925 32.3099 15.7573 31.6926 18.8106C31.0753 21.8638 29.5515 24.6684 27.314 26.8698Z"
              class="bot"
            />
            <path
              d="M22.3151 14.635L16.5326 8.72502C16.4629 8.65473 16.3799 8.59893 16.2885 8.56085C16.1971 8.52278 16.0991 8.50317 16.0001 8.50317C15.9011 8.50317 15.803 8.52278 15.7117 8.56085C15.6203 8.59893 15.5373 8.65473 15.4676 8.72502L9.68509 14.6425C9.54516 14.7836 9.43466 14.951 9.35998 15.1351C9.28531 15.3192 9.24795 15.5164 9.25009 15.715V22C9.24951 22.384 9.39617 22.7535 9.65987 23.0325C9.92357 23.3116 10.2842 23.4789 10.6676 23.5H21.3326C21.7159 23.4789 22.0766 23.3116 22.3403 23.0325C22.604 22.7535 22.7507 22.384 22.7501 22V15.715C22.7507 15.3122 22.5947 14.925 22.3151 14.635ZM14.5001 22V17.5H17.5001V22H14.5001ZM21.2501 22H19.0001V16.75C19.0001 16.5511 18.9211 16.3603 18.7804 16.2197C18.6398 16.079 18.449 16 18.2501 16H13.7501C13.5512 16 13.3604 16.079 13.2198 16.2197C13.0791 16.3603 13.0001 16.5511 13.0001 16.75V22H10.7501V15.685L16.0001 10.3225L21.2501 15.715V22Z"
              fill="white"
            />
          </svg>

          <div>&nbsp; Acompanhar atendimento</div>
        </Button>
      </div>
      <Button layout="remote-how" class="more" @click="showJob = false"
        >MENOS DETALHES</Button
      >
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  components: {
    Button,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
    map: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Function | Boolean,
      required: false,
    },
    remote: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showJob: false,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 35px;
  width: 250px;
  font-size: 14px;
  margin-right: 33px;
  margin-bottom: 30px;
  height: 335px;
  @media (max-width: $small) {
    width: 100%;
  }
  &.detail {
    background-color: #f8f8f8;
  }
  .title {
    font-size: 18px;
    padding-bottom: 23px;
    text-align: center;
  }
  .status {
    line-height: 24px;
    padding: 0px 20px;
    border-radius: 50px;
    text-align: center;

    @media (max-width: $medium) {
      font-size: 12px;
    }
  }
  .opened {
    .header {
      margin-bottom: 25px;
    }
    .titled {
      font-size: 15px;
      margin-left: 7px;
    }
    .content {
      height: 220px;
      overflow-y: auto;
      margin-bottom: 15px;
    }
    .more {
      margin-top: 0px;
    }
  }
  .id {
    padding: 6px;
    font-size: 11px;
    border-radius: 50px;
    width: normal;
    height: 12px;
    min-width: 45px;
    text-align: center;
  }
  .date {
    margin-top: 30px;
    span {
      color: rgba(55, 57, 70, 0.5);
    }
  }
  .more {
    margin-top: 75px;
  }

  .sub {
    font-size: 14px;
    color: rgba(55, 57, 70, 0.5);
  }
  .problem,
  .info {
    padding-bottom: 25px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .goMap {
    margin-top: 25px;
  }
  .address {
    padding-bottom: 25px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
